var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("已跳转乐居智能大屏页面，请在新页面查看")])}
var staticRenderFns = []

export { render, staticRenderFns }